<owl-carousel-o [options]="customOptions" *ngIf="articoli.length > 0">
  <ng-container *ngFor="let articolo of articoli">
    <ng-template carouselSlide>
      <div class="banner-card" [style.background-color]="articolo.color1 || bgColor">
        <div class="content-wrapper">
          <div class="text-content">
            <div class="subtitle">{{ 'BANNER.DISHOFTHEDAY' | translate }}</div>
            <h2 class="title" [style.color]="articolo.color2 || accentColor">{{ articolo.descart }}</h2>
            <div class="price" [style.color]="articolo.color2 || accentColor">
              € {{ articolo.prezzo | number: '1.2-2' }}
            </div>
          </div>
          <div class="image-wrapper" *ngIf="articolo.cdn_url">
            <img [src]="articolo.cdn_url" alt="{{ articolo.descart }}" />
          </div>
        </div>
      </div>
    </ng-template>
  </ng-container>
</owl-carousel-o>
